import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLanguageFromURL } from '../../i18n';

/**
 * Syncs the URL language prefix with i18next language state.
 * Wrap your routes with this component.
 */
const LanguageWrapper = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlLang = getLanguageFromURL(location.pathname);
    if (urlLang !== i18n.language) {
      i18n.changeLanguage(urlLang);
    }

    /* Nothing else in the app touches `<html lang>`. The prerendered
       static files set it correctly, but every client-side render — which
       is what an actual visitor gets after the first navigation — left
       the whole Spanish site declared as English. That mis-pronounces the
       page in a screen reader and contradicts the hreflang pair the same
       document advertises. */
    if (document.documentElement.lang !== urlLang) {
      document.documentElement.lang = urlLang;
    }
  }, [location.pathname, i18n]);

  return <>{children}</>;
};

export default LanguageWrapper;
